module.exports = __webpack_public_path__ + "media/images/sales/early/text-mv-duedate-year-2027-3422b6929124a295bd8ff946efe8e881.svg";